import styled from "@emotion/styled";
import React from "react";
import { Link } from "react-router-dom";
import { CustomThemeType } from "../../context/Providers";

const FooterWrapper = styled.div<{ theme?: CustomThemeType }>`
  background-color: color-mix(
    in hsl,
    ${(p) => p.theme.brand},
    ${(p) => p.theme.background} 90%
  );
  font-family: "Inter";
  font-size: 0.75rem;
  color: ${(p) => p.theme.brand};
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 4rem 0 3.5rem;
  @media (max-width: 500px) {
    padding: 3rem 0 2.5rem;
  }
`;

const ContentRow = styled.div<{ theme?: CustomThemeType }>`
  width: 90%;
  max-width: 1080px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  color: color-mix(
    in srgb,
    ${(p) => p.theme.brand},
    ${(p) => p.theme.background} 50%
  );
  font-size: clamp(0.9rem, 1.2vw, 1.15rem);
  flex-wrap: wrap;
  text-align: center;
  @media (max-width: 720px) {
    flex-direction: column;
    gap: 0.75rem;
  }
`;

const LinkGroup = styled.nav<{ theme?: CustomThemeType }>`
  display: flex;
  gap: 1.25rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
`;

const FooterLink = styled(Link)<{ theme?: CustomThemeType }>`
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  padding-bottom: 0.1rem;
  transition: border-color 0.2s ease;
  &:hover {
    border-color: currentColor;
  }
`;

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  return (
    <FooterWrapper>
      <ContentRow>
        <span>© 2025 Blunt Solutions. All rights reserved.</span>
        <LinkGroup>
          <FooterLink to="/support">Support</FooterLink>
          <FooterLink to="/terms">Terms of Use</FooterLink>
          <FooterLink to="/privacy">Privacy Policy</FooterLink>
        </LinkGroup>
      </ContentRow>
    </FooterWrapper>
  );
};

export default Footer;
